module.exports = __webpack_public_path__ + "img/20.75bc773c.jpg";